import Ledger from './ledger'
import { autoserializeAs, inheritSerialization } from 'cerialize'
import { IRevenue, RevenueStatus } from './interfaces'

@inheritSerialization(Ledger)
export default class Revenue extends Ledger implements IRevenue {

  // public static create(customerId: string, name: string, unit: number, perUnit: number,
  //                      vatPercent: number = 0, status: RevenueStatus, issueDate: Date = new Date()): Revenue {
  //   return new Revenue({
  //     type: 'rev',
  //     id: '',
  //     name,
  //     unit,
  //     perUnit,
  //     vatPercent,
  //     issueDate,
  //     customerId,
  //     invoiceHash: '',
  //     invoiceId: '',
  //     status,
  //   })
  // }

  @autoserializeAs('invoice_id')
  public invoiceId: string = ''

  @autoserializeAs('invoice_hash')
  public invoiceHash: string = ''

  @autoserializeAs('customer_id')
  public customerId: string = ''

  @autoserializeAs('status')
  public status: RevenueStatus = 'created'

  constructor() {
    super('rev')
  }

  /**
   * Method to allow user to set associated invoice document to
   * revenue item.
   *
   * @param id
   * @param hash
   */
  public associateInvoice(id: string, hash: string) {
    this.invoiceId = id
    this.invoiceHash = hash
    this.status = 'invoiced'
  }
}
